module.exports = __webpack_public_path__ + "img/hc_pro_four_7.0c3258e8.jpg";